// extracted by mini-css-extract-plugin
module.exports = {"msgLeft":"UserMessages_msgLeft__2dffV","msgAvatarFriend":"UserMessages_msgAvatarFriend__3sPSc","textMsg":"UserMessages_textMsg__3Su-A","timeMsg":"UserMessages_timeMsg__3mLZQ"};